import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { SampleAction, SampleLifecycle } from './types';

export function evaluateSampleNextAction({
  state,
  sampleId,
  versionArchived,
}: {
  state: SampleLifecycle;
  sampleId: number | undefined;
  versionArchived: boolean;
}) {
  if (versionArchived) return SampleAction.None;

  if (!sampleId) {
    return SampleAction.InitiateSampling;
  }

  switch (ensureEnumNumber(SampleLifecycle, state)) {
    case SampleLifecycle.Nothing: {
      return SampleAction.None;
    }
    case SampleLifecycle.SampleAccepted: {
      return SampleAction.None;
    }
    case SampleLifecycle.SampleBeingPreparedAtSupplier: {
      return SampleAction.MarkSampleReceivedFromSupplier;
    }
    case SampleLifecycle.SampleBeingPreparedReadySampleDatePassed: {
      return SampleAction.MarkSampleReceivedFromSupplier;
    }
    case SampleLifecycle.SampleReceivedFromSupplier: {
      return SampleAction.SendToInternalOrHandlePa;
    }
    case SampleLifecycle.SampleUnhandled: {
      return SampleAction.SendSampleOrHandlePa;
    }
    case SampleLifecycle.SampleLost: {
      return SampleAction.RestartSampling;
    }
    case SampleLifecycle.SampleCancelled: {
      return SampleAction.RestartSampling;
    }
    case SampleLifecycle.SampleRejected: {
      return SampleAction.RestartSampling;
    }
    case SampleLifecycle.SampleInBrandTransportRequestAwaitingShipment: {
      return SampleAction.UpdateTransportRequestWithoutShipment;
    }
    case SampleLifecycle.SampleInBrandTransportRequestAwaitingDispatch: {
      return SampleAction.None;
    }
    case SampleLifecycle.SampleInBrandTransportRequestDispatched:
    case SampleLifecycle.SampleReceivedAtBrand:
    case SampleLifecycle.SampleOnHold: {
      return SampleAction.SentToCustomerHandlePa;
    }
    case SampleLifecycle.SampleInInternalTransportRequestAwaitingShipment: {
      return SampleAction.UpdateTransportRequestWithoutShipment;
    }
    case SampleLifecycle.SampleInInternalTransportRequestAwaitingDispatch: {
      return SampleAction.None;
    }
    case SampleLifecycle.SampleInInternalTransportRequestDispatched: {
      return SampleAction.UnpackShipment;
    }
  }

  return SampleAction.None;
}
